import Joi from "joi";

export interface UserResetPassword {
  Email: string;
  OldPassword: string;
  NewPassword: string;
  ConfirmNewPassword: string;
  [key: string]: any;
}

export const resetPasswordSchema = Joi.object({
  Email: Joi.string()
    .email({ tlds: { allow: false } })
    .required()
    .messages({
      "string.email": "Invalid email format.",
      "any.required": "Email is required.",
    }),

  OldPassword: Joi.string()
    .required()
    .messages({
      "any.required": "Old password is required.",
    })
    .label("Email"),

  NewPassword: Joi.string()
    .min(8)
    .pattern(
      /^[A-Za-z\d!@#$%^&*()_+={}\[\]:;"'<>,.?/~`|\\-]+$/,
      "valid characters"
    )
    .pattern(/[A-Z]/, "uppercase letter")
    .pattern(/\d/, "number")
    .pattern(/[^A-Za-z\d]/, "symbol")
    .required()
    .invalid(Joi.ref("OldPassword"))
    .messages({
      "string.pattern.base":
        "New password must include at least one uppercase letter, one number, and one symbol.",
      "any.invalid": "New password cannot be the same as the old password.",
      "any.required": "New password is required.",
    })
    .label("New Password"),

  ConfirmNewPassword: Joi.string()
    .valid(Joi.ref("NewPassword"))
    .required()
    .messages({
      "any.only": "Confirm password must match the new password.",
      "any.required": "Confirm password is required.",
    })
    .label("Confirm New Password"),
});
